export default __webpack_public_path__ + "static/media/settings.5ea194e4.svg";